import { Workspace } from "@/components/graphql/schema.graphql";

type PermissionWorkspace = Pick<
  Workspace,
  "isEnterprise" | "isChildWorkspace"
> & { myPermissions: string[] };

const BASIC_WORKSPACE_PERMISSION = "workspace:basic";

export const hasUsablePermissions = (workspace: {
  myPermissions: string[];
}): boolean => {
  return workspace.myPermissions.some((p) => p !== BASIC_WORKSPACE_PERMISSION);
};

const MEMBER_ONLY_PERMISSIONS = new Set(["workspace:basic", "project:view"]);

export const isHiddenHierarchyParent = (
  workspace: PermissionWorkspace,
): boolean => {
  return (
    workspace.isEnterprise === true &&
    workspace.isChildWorkspace === false &&
    workspace.myPermissions.every((p) => MEMBER_ONLY_PERMISSIONS.has(p))
  );
};
